import {CampaignFilter} from '@dms/api/shared';

import {compactVehicleSelectionFilter} from '../../../utils/compactVehicleSelectionFilter';
import {PromoPhotosFormType} from '../types/PromoPhotosFormType';
import {VehicleSelectionMode} from '../types/VehicleSelectionMode';

// A REGULAR photo "by conditions" sends its compacted rules; "all vehicles" sends null, and so does
// a FINANCING photo, which the BE rejects with a selection (400 `DMS-PH-PH-0005`).
export const getPromoPhotoVehicleSelection = (
  data: Pick<PromoPhotosFormType, 'type' | 'vehicleSelectionMode' | 'filter'>
): CampaignFilter | null =>
  data.type === 'REGULAR' && data.vehicleSelectionMode === VehicleSelectionMode.BY_CONDITIONS
    ? compactVehicleSelectionFilter(data.filter)
    : null;
